export default function main({ children }) {
  return <div className="container p-3">{children}</div>;
}
